import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { createSelector } from 'reselect';
import { isFeatureEnabled } from 'state/selectors/common/userFeatures';
import { AppState } from 'state/state.model';
import { isSecondaryMarketCpOrderEnabledForUser } from 'state/user/user.selector';

export const getAvailableOrderTypes = createSelector(
  (state: AppState) => isFeatureEnabled(state, 'batchSecondaryMarketQuoteParis'),
  isSecondaryMarketCpOrderEnabledForUser,
  (state: AppState) => isFeatureEnabled(state, 'batchSecondaryLiveQuoteParis'),
  (isBatchQuoteEnabled, isCpOrderEnabled, isLiveQuoteEnabled) => {
    const result: OrderType[] = [];
    if (isCpOrderEnabled) {
      result.push('cp-order');
    }
    if (isBatchQuoteEnabled) {
      result.push('ebiz-quote');
    }
    if (isLiveQuoteEnabled) {
      result.push('live-quote');
    }
    return result;
  },
);

export const getDefaultOrderType = createSelector(getAvailableOrderTypes, orderTypes => orderTypes[0]);
